<template>
  <div
    role="checkbox"
    tabindex="0"
    :aria-checked="isActive"
    :class="[ { 'border-neutral-200 bg-transparent' : !isActive }, { 'border-petrol-500 bg-petrol-50' : isActive }, 'rounded-md border-2 inline-block font-semibold cursor-pointer']"
    @click="toggle"
    @keydown.enter="toggle"
  >
    <div class="flex items-center cursor-pointer">
      <div :class="['py-4 px-4']">
        <div v-if="$slots.icon">
          <slot name="icon" />
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  id: {
    type: String,
    default: null
  },
  name: {
    type: String,
    default: null
  },
  modelValue: {
    type: [Boolean, String, Number, Array],
    default: null
  },
  value: {
    type: [String, Number],
    default: ''
  },
  trueValue: {
    type: [Boolean, String, Number],
    default: true
  },
  falseValue: {
    type: [Boolean, String, Number],
    default: false
  },
  error: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits<{(e: 'update:modelValue', value: string): void}>()

const isActive = computed(() => {
  if (Array.isArray(props.modelValue)) {
    return props.modelValue.includes(props.value)
  } else {
    return !!props.modelValue
  }
})

const toggle = () => {
  if (Array.isArray(props.modelValue)) {
    if (props.modelValue.includes(props.value)) {
      emit('update:modelValue', props.modelValue.filter(x => x !== props.value))
    } else {
      emit('update:modelValue', [...props.modelValue, props.value])
    }
  } else {
    emit('update:modelValue', !isActive.value ? props.trueValue : props.falseValue)
  }
}
</script>

